import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as e, hi as r, bo as s, fi as a } from "./abstract-base-8edf0a84-e11d45a3.js";
import { X as o } from "./focus-trap-9eb080a8-1674051e.js";
import "./state-b4c9cc73-ee633f6c.js";
import "./lifecycle-decorators-ecc4e836-92da4b80.js";
import "./helper-dd9a664c-e404f685.js";
import "./keys-b2183e45-74d07070.js";
var i = e(_templateObject || (_templateObject = _taggedTemplateLiteral([":host{display:block}\n"]))),
  t = "beacon-paginated-tabs";
var n = /*#__PURE__*/function (_r) {
  _inherits(n, _r);
  function n() {
    var _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.beaconTagName = t;
    return _this;
  }
  _createClass(n, [{
    key: "render",
    value: function render() {
      return s(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(n), "styles", this), i];
    }
  }]);
  return n;
}(r(a, o()));
n.tagName = t;
export { n as BeaconPaginatedTabs };